<template>
  <div>
    <i
      v-for="index in 5"
      :key="index"
      :style="index <= parseInt(num) ? 'color:#F07954' : ''"
      class="iconfont icon-xingxing"
    ></i>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-20
@create:wq
*/
export default {
  name: "",
  props: {
    fontSize: {
      //   type: String,
      default: 30,
    },
    num: {
      //   type: String,
      default: 4,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    // console.log(this.num);
  },
  methods: {},
};
</script>
<style scoped>
i {
  color: #cccccc;
  margin-right: 0.18rem;
}
i:last-child {
  margin-right: 0;
}
</style>
